// Modules
import React from 'react';
import store from '../store';
import SingleTeeInput from './singleTee';

export default function menuCourseOutliner(props){
    console.log(store.getState());
    return(
    <div id="match-tee-outliner" className="">
        <h5>Course Tees</h5>
        <SingleTeeInput teeNum="1" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="2" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="3" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="4" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="5" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="6" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="7" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="8" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="9" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="10" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="11" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="12" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="13" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="14" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="15" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="16" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="17" socket={props.socket}/>
        <div className="teeSpacer"/>
        <SingleTeeInput teeNum="18" socket={props.socket}/>
        <div className="teeSpacer"/>
    </div>
    );
}


// WEBPACK FOOTER //
// ./src/comps/gameOutliner.js